import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";
import MatchMiaiLevelBase from "./MatchMiaiLevelBase";

const {ccclass, property} = cc._decorator;

/** 完成第一关事件 */
const c_end_first_event = '2';
const c_end_first_special_event = '5';
/** 完成第二关事件 */
const c_end_second_event = '3';
/** 完成第二关再次进入的事件 */
const c_end_game_event = '4';
/** 完成第二关再次进入的事件 */
const c_end_game_event2 = '8';

@ccclass
export default class MatchMiaiLayer extends BasePopUpLayer {

    private levelScript: MatchMiaiLevelBase = null;

    start(){
        O1HD.getModules().uiControlModule.hideLoading();
        this.initLayer();
       
        utilsView.enterLayerDispose(UIKind.UILayerTag.MATCH_MIAI, this.node);
        O1HD.on(MessageEventKind.EventName.START_MATCH_MIAI_SECOND_LEVEL, this.startMatchMiaiSecondLevel, this);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.MATCH_MIAI);
    }

    initLayer() {
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        if (matchMiaiData.bEndGame) {
            if (matchMiaiData.bEndSecond) {
                if (matchMiaiData.bBridePrice) {
                    this.openEndGameEvent2();
                } else {
                    this.openEndGameEvent();
                }
            } else {
                this.openFinishEvent();
            }
        } else {
            this.openFirstLevelLayer();
        }
    }
    
    openFinishEvent(bSpecial: boolean = false) {
        this.openMainEvent(bSpecial ? c_end_first_special_event : c_end_first_event);
    }

    openEndSecondLevelEvent() {
        this.openMainEvent(c_end_second_event);
    }

    openEndGameEvent() {
        this.openMainEvent(c_end_game_event);
    }

    openEndGameEvent2() {
        this.openMainEvent(c_end_game_event2);
    }

    openMainEvent(id: string) {
        let data = {
            id: id
            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            , onComplete: ()=> {
                
            }
            , exitLayer: ()=> {
                this.destroyNode();
            }
        }
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
    }

    startMatchMiaiSecondLevel() {
        this.openSecondLevelLayer();
    }
    
    openFirstLevelLayer() {
        utilsView.openPopupLayer(
            'prefab/MatchMiaiLevel1'
            , BUNDLE_SMALL_NAME.matchMiaiBundle
            , this.node
            , {
                parent: this
            }
            , 0
            , (node)=> {
                this.levelScript = node.getComponent(MatchMiaiLevelBase);
            }
        );
    }

    openSecondLevelLayer() {
        if (this.levelScript) {
            this.levelScript.destroyNode();
            this.levelScript = null;
        }
        utilsView.openPopupLayer(
            'prefab/MatchMiaiLevel2'
            , BUNDLE_SMALL_NAME.matchMiaiBundle
            , this.node
            , {
                parent: this
            }
            , 1
            , (node)=> {
                this.levelScript = node.getComponent(MatchMiaiLevelBase);
            }
        );
    }
}
